import { render, staticRenderFns } from "./CarouselFrame.vue?vue&type=template&id=4ae138e9&scoped=true&"
import script from "./CarouselFrame.vue?vue&type=script&lang=ts&"
export * from "./CarouselFrame.vue?vue&type=script&lang=ts&"
import style0 from "./CarouselFrame.vue?vue&type=style&index=0&id=4ae138e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae138e9",
  null
  
)

export default component.exports